import get from 'lodash/get';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import VideoVisitBtn from '../../../VideoVisitBtn';
import ConfirmVisitByPatientBtn from '../../../ConfirmVisitByPatientBtn';

import { URGENT_VISIT_TYPE_CODE } from '../../../../../../constants';

const VisitButtons = ({
  appointment,
  handleStartVideoVisit,
  showConfirmByPatientButton,
  showVideoVisitButton,
  isJoinVirtualVisitByCode,
}) => {
  const code = get(appointment, 'visitType.code');

  const text = code === URGENT_VISIT_TYPE_CODE ? 'common.joinVisit' : null;

  return (
    <Fragment>
      {showVideoVisitButton && (
        <VideoVisitBtn
          title={text}
          disabled={isJoinVirtualVisitByCode}
          onStartVideoVisit={handleStartVideoVisit}
        />
      )}
      {showConfirmByPatientButton && (
        <ConfirmVisitByPatientBtn
          userId={appointment.userId}
          appointmentId={appointment.id}
        />
      )}
    </Fragment>
  );
};

VisitButtons.propTypes = {
  appointment: PropTypes.object.isRequired,
  handleStartVideoVisit: PropTypes.func.isRequired,
  showConfirmByPatientButton: PropTypes.bool.isRequired,
  showVideoVisitButton: PropTypes.bool.isRequired,
  isJoinVirtualVisitByCode: PropTypes.bool.isRequired,
};

export default VisitButtons;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentCard/components/VisitButtons/index.jsx